import React, { Fragment, useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import BloodDonation1 from '../../images/blood-donation/blood1.webp'
import BloodDonation2 from '../../images/blood-donation/blood2.webp'
import BloodDonation3 from '../../images/blood-donation/blood3.webp'
import BloodDonation4 from '../../images/blood-donation/blood4.webp'
import BloodDonation5 from '../../images/blood-donation/blood5.webp'
import BloodDonation7 from '../../images/blood-donation/blood7.webp'
import BloodDonation8 from '../../images/blood-donation/blood8.webp'
import BloodDonation9 from '../../images/blood-donation/blood9.webp'
import BloodDonation10 from '../../images/blood-donation/blood10.webp'
import BloodDonation12 from '../../images/blood-donation/blood12.webp'
// import BloodDonation6 from '../../images/blood-donation/blood6.webp'
// import BloodDonation11 from '../../images/blood-donation/blood11.webp'

import metadataJSON from "../../data/metadata.json";
import schemadataJSON from "../../data/schemadata.json";
import { Helmet } from 'react-helmet';



const BloodDonation = ({ path }) => {
    
    // Setting metadata and schemadata 
    const [metadata, setMetadata] = useState({title: "JJFIndia | Our Initiative"});
    const [schemadata, setSchemadata] = useState({});
    
    // Getting the schemadata and setting the schema data. 
    useEffect(() => {
        let tempMetadata = metadataJSON[path];
        let tempSchemadata = schemadataJSON[path];

        if(tempMetadata){
        setMetadata(tempMetadata);
        }else {
        tempMetadata = {
            title: "JJFIndia | Gallery",
            description: "JJFIndia Gallery page",
            keywords: "",
            robots: "index, follow",
            canonical: "https://jjfindia.com/gallery/tree-plantation",
            openGraph: {
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page",
                url: "https://jjfindia.com/gallery/tree-plantation"
            },
            twitter: {
                card: "summary_large_image",
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page"
            }
        }

        setMetadata(tempMetadata);
        }

        // setting schema data 
        if(tempSchemadata) {
            setSchemadata(tempSchemadata);
        }

    }, [path]);

    return (
        <>
            <Helmet>
                {/* Basic Meta Tags */}
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <meta name="robots" content={metadata.robots} />
        
                {/* Canonical URL */}
                <link rel="canonical" href={metadata.canonical} />
        
                {/* Open Graph */}
                <meta property="og:title" content={metadata.openGraph?.title} />
                <meta property="og:description" content={metadata.openGraph?.description} />
                <meta property="og:url" content={metadata.canonical} />
        
                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content={metadata.twitter?.title} />
                <meta name="twitter:description" content={metadata.twitter?.description} />
                
                {/* Setting up schema data */}
                <script  type="application/ld+json" >{JSON.stringify(schemadata, null, 2)}</script>
            </Helmet>

            <Fragment>
                <Header hclass={'header--styleFour'} />
                <main className="page_content">
                    <PageTitle pageTitle={'Blood Donation'} pagesub={'Gallery'} />

                    {/* <div className='mt-5 pt-4 pb-100'>
                        <About2 />
                    </div> */}

                    <section className="blog pt-60 ">
                        <div className="container">
                            <div className="row align-items-end">
                                <div className="col-12">
                                    <div className="sectionTitle mb-40" id='feature'>
                                        <span className="sectionTitle__small justify-content-center">
                                            <i className="fa-solid fa-heart btn__icon"></i>Blood Donation
                                        </span>
                                        <h1 className="sectionTitle__big text-center">Blood Donation</h1>
                                        <p className='text-center' style={{ fontSize: '24px' }}>Snapshots of life-saving moments during our blood donation drives.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            {/* <Link to="#" */}
                                            {/* onClick={(e) => e.preventDefault()} className="blogBlock__figure__link"> */}
                                            <img src={BloodDonation1} alt="Inside blood donation bus" className="blogBlock__figure__image" />
                                            {/* </Link> */}
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation2} alt="Registration and donor support area" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation3} alt="Group in front of blood donation bus" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation4} width={225} loading='lazy' alt="Donor resting inside blood donation bus." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation5} width={225} loading='lazy' alt="Donor seated inside the blood donation bus." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                {/* <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation6} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div> */}
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation7} width={225} loading='lazy' alt="Donor giving thumbs-up during blood donation." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation8} width={400} loading='lazy' alt="Group in front of blood donation bus." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation10} width={400} loading='lazy' alt="Volunteers standing outside blood donation bus." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                {/* <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation11} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div> */}
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation12} width={400} loading='lazy' alt="Donors and volunteers posing near blood donation bus." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={BloodDonation9} width={400} loading='lazy' alt="Volunteers standing outside blood donation bus." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

                </main>
                <Footer />
                <Scrollbar />
            </Fragment>
        </>
    )
};

export default BloodDonation;
